import * as React from 'react';
import { gold } from '../../../../getLPTheme';
import 'react-multi-carousel/lib/styles.css';
import { Box, Button, Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';




//-------------------- Carousel de Hoteles  ------------------------

interface MyhotelesCards {
    id: number,
    img: string,
    title: string,
    description: string,
    link: string,
  }
  
interface Props {
hotelesCards: Array<any>;
autoPlay?: boolean;
showButtons?: boolean;
}

    
export default function Carousel(props: Props) {
const [selectedIndex, setSelectedIndex] = useState(0);
const [selectedCardImg, setSelectedCardImg] = useState(props.hotelesCards[0].img);
const [selectedCardTitle, setSelectedCardTitle] = useState(props.hotelesCards[0].title);
const [selectedCardDescription, setSelectedCardDescription] = useState(props.hotelesCards[0].description);
const [selectedCardLink, setSelectedCardLink] = useState(props.hotelesCards[0].link);
const [loaded, setLoaded] = useState(false);

useEffect(() => {
    if (props.autoPlay || !props.showButtons) {
    const interval = setInterval(() => {
        selectNewCard(selectedIndex, props.hotelesCards);
    }, 1000);
    return () => clearInterval(interval);
    }
});

const selectNewCard = (index: number, hotelesCards: Array<any>, next = true) => {
    setLoaded(false);
    setTimeout(() => {
    const condition = next ? selectedIndex < hotelesCards.length - 1 : selectedIndex > 0;
    const nextIndex = next ? (condition ? selectedIndex + 1 : 0) : condition ? selectedIndex - 1 : hotelesCards.length - 1;
    setSelectedCardImg(hotelesCards[nextIndex].img);
    setSelectedCardTitle(hotelesCards[nextIndex].title);
    setSelectedCardDescription(hotelesCards[nextIndex].description);
    setSelectedCardLink(hotelesCards[nextIndex].link);
    setSelectedIndex(nextIndex);
    }, 500);
};

const previous = () => {
    selectNewCard(selectedIndex, props.hotelesCards, false);  // Le digo que next = false
};

const next = () => {
    selectNewCard(selectedIndex, props.hotelesCards);  // por default Next = true
};

return (
    <Box>
    {/* Aca establezco que si es pantalla chica no muestre nada.  */}
    <Box sx={{display: {xs: "none", md: "flex", sm:"flex"}, alignItems: "center", justifyContent: "center", direction: "row" }}> 
        <Box sx={{paddingRight:1,}}>
        <Button onClick={previous} sx={{backgroundColor:"#DCDAD9", ":hover":{backgroundColor: gold[500], color:"white"}}}>{<ArrowBackIosIcon/>}</Button>
        </Box>
        <Card sx={{width: {xs: 310, sm: 400}, p:2, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
            <CardActionArea href={selectedCardLink} >
                <CardMedia component="img" image={selectedCardImg} height="200" alt="Card Image"/>
                <CardContent>
                <Typography gutterBottom sx={{fontSize: {xs: 16, sm:24}, fontWeight:"bold" }} component="div">
                    {selectedCardTitle}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {selectedCardDescription}
                </Typography>
                </CardContent> 
            </CardActionArea>
        </Card>
        <Box sx={{paddingLeft:1,}}>
        <Button onClick={next} sx={{backgroundColor:"#DCDAD9", ":hover":{backgroundColor: gold[400], color:"white"}, }}>{<ArrowForwardIosIcon/>}</Button> 
        </Box>
    </Box>

    {/* Aca establezco que si es pantalla grande no muestre nada.  */}
    <Box sx={{display: {xs: "flex", md: "none", sm:"none"}, alignItems: "center", justifyContent: "center", flexDirection: "column" }}> 
        <Card sx={{width: {xs: 310, sm: 400}, p:2, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
        <CardActionArea href={selectedCardLink} >
            <CardMedia component="img" image={selectedCardImg} height="200" alt="Card Image"/>
            <CardContent>
                <Typography gutterBottom sx={{fontSize: {xs: 16, sm:24}, fontWeight:"bold" }} component="div">
                {selectedCardTitle}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                {selectedCardDescription}
                </Typography>
            </CardContent> 
        </CardActionArea>
        </Card>
        <Box sx={{p: 1, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: 'row' }}>
        <Box sx={{paddingRight:3,}}>
            <Button onClick={previous} sx={{backgroundColor:"#DCDAD9", ":hover":{backgroundColor: gold[500], color:"white"}}}>{<ArrowBackIosIcon/>}</Button>
        </Box>
        <Box sx={{}}>
            <Button onClick={next} sx={{backgroundColor:"#DCDAD9", ":hover":{backgroundColor: gold[400], color:"white"}, }}>{<ArrowForwardIosIcon/>}</Button> 
        </Box>
        </Box>
    </Box>
    </Box>
    );
}
  
  
  //-------------------- Fin Carousel de Hoteles  --------------------